import _BaseUserProfile from 'Models/UserProfile/_BaseUserProfile';

export default class EmergencyContact extends _BaseUserProfile {
  component = 'EmergencyContactForm';
  props = {
    title: null,
    errorMessage: null,
    additionalFormInModal: false,
    modalTitle: null,
    additionalFormComponent: null,
  };
}
